export const MSG_CASHIER_SUCCESS = "Order Placed Successfully!";
export const MSG_CASHIER_FAILED = "Order Placed Failed!";
export const MSG_EMPTY_CART = "Cannot place an order with an empty cart!";

export const MSG_VOUCHER_SUCCESS = "Voucher added successfully.!";
export const MSG_VOUCHER_FAILED = "Voucher added Failed!";
export const MSG_VOUCHER_NO_MATCH = "No voucher matches the entered code.!";
export const MSG_VOUCHER_NOT_AVAILABLE =
  "No vouchers available for the entered code.";

export const MSG_VOUCHER_ENTER = "Please enter a voucher code!";

export const MSG_NOTE_ENTER = "Please enter a note id.";
export const MSG_NOTE_NOT_FOUND = "No credit or exchange note found for this id.";
export const MSG_NOTE_SEARCH_FAILED = "Failed to search note. Please try again.";
export const MSG_NOTE_ALREADY_CLAIMED = "This note has already been refunded or claimed.";
export const MSG_NOTE_EXPIRED = "This note has expired and can no longer be claimed.";
export const MSG_NOTE_APPLIED_SUCCESS = "Note credit applied to this bill.";

export const LOGIN_SUCCESS = "Hi, Welcome Back!";
export const LOGIN_FAILED =
  "Login failed. Please check your credentials and try again.!";

export const ADD_TO_CART = "Please log in to add items to the cart.";

export const MSG_GROUPACCESS_SUCCESS = "Group access mapped successfully!";
export const MSG_GROUPACCESS_FAILED = "Group access mapped failed!";

export const MSG_KITCHEN_SUCCESS = "Order Ready!";
export const MSG_KITCHEN_FAILED = "Order Not Ready!";

// Change Password Page msgs
export const MSG_OLD_PW_REQ = "Old password is required!";
export const MSG_NEW_PW_LENGTH = "New password must be at least 8 characters!";
export const MSG_PW_STRENGTH = "New password is too weak!";
export const MSG_PW_NOT_MATCH =
  "New password and confirm password do not match!";

export const MSG_OLD_PW_VER = "Old password verified successfully!";
export const MSG_OLD_PW_INC = "Old password is incorrect!";

export const MSG_PW_CHANGE_SUC = "Password Updated Successfully!";
export const MSG_PW_CHANGE_FAI = "Password update failed!";

export const MSG_DAYEND_SUC = "Day End Process completed successfully!";
export const MSG_DAYEND_FAI =
  "Failed to complete Day End Process. Please try again!";

// src/utils/DialogMessages.js

export const DIALOG_TITLES = {
  DELETE: "Confirm Delete",
  UPDATE: "Confirm Update",
};

export const DIALOG_MESSAGES = {
  DELETE: "Are you sure you want to delete this order?",
  UPDATE: "Are you sure you want to update this order?",
};
